<template>
  <div>
    <div class="container_wrapper" v-if="Facelist" v-loading="!Facelist">
      <!-- 排序 -->
      <div class="SortItem">
        <div class="resultTotal">
          共 <span>{{ hit }}</span> 条结果
        </div>
        <div class="sortBtn clear">
          <div
            class="orderByName"
            :class="
              searchData.sorts[0]['feild'] === 'BookTitle' ? 'selectBtn' : ''
            "
            @click="handleSort('BookTitle')"
          >
            按志书名排序
            <span class="iconfont">&#xe636;</span>
          </div>
          <div
            class="orderByTime"
            :class="searchData.sorts[0]['feild'] === 'Date' ? 'selectBtn' : ''"
            @click="handleSort('Date')"
          >
            按出版时间排序 <span class="iconfont">&#xe636;</span>
          </div>
        </div>
      </div>
      <!--(index+1) + (pageNo-1) * pageSize-->
      <div
        class="container-inner clear"
        v-for="(item, index) of Facelist"
        :key="index"
      >
        <div class="left">
          <p class="itemTitle" :title="item.Title">
            <a class="title"
              >{{ index + 1 + (curPageFlag - 1) * pageSizeFlag }}.
            </a>
            <a class="title title_hl" v-html="item.Title_HL || item.Title"></a>
            <span
              class="itemArea"
              v-if="!item.City && !item.County && item.Province"
              >{{ item.Province }}</span
            >
            <span class="itemArea" v-if="!item.County && item.City">{{
              item.City
            }}</span>
            <span class="itemArea" v-if="item.County">{{ item.County }}</span>
          </p>
          <p class="itemMessage">
            <span v-if="item.BookTitle" class="item">来源名称：</span
            ><span
              class="item-mess"
              :title="item.BookTitle"
              v-if="item.BookTitle"
              v-html="item.BookTitle_HL || item.BookTitle"
            ></span>
            <span v-if="item.Editor" class="item">编纂人员：</span
            ><span
              class="item-mess"
              v-if="item.Editor"
              :title="item.Editor"
              v-html="item.Editor_HL || item.Editor"
            ></span>
            <span v-if="item.Publisher" class="item">出版单位：</span
            ><span
              class="item-mess"
              v-if="item.Publisher"
              :title="item.Publisher"
              v-html="item.Publisher_HL || item.Publisher"
            ></span>
            <span v-if="item.Date" class="item">出版时间：</span
            ><span class="item-mess" v-if="item.Date" :title="item.Date">{{
              item.Date
            }}</span>
            <span v-if="item.Type" class="item">条目类型：</span
            ><span class="item-mess-type" v-if="item.Type" :title="item.Type">{{
              item.Type
            }}</span>
          </p>
          <div style="background: #f2eeeb; padding: 20px" v-if="item.Content">
            <p class="itemContent" v-if="item.Content">
              主要内容：<span
                class="content"
                v-html="item.Content_HL || item.Content"
                :title="item.Content"
              ></span>
            </p>
          </div>
        </div>
        <div class="right">
          <div class="reading" @click="handleItemRead(item.Id)">
            <span class="iconfont">&#xe612;</span>在线阅读
          </div>
          <div class="loaddown" @click="handleItemDown(item.Id)">
            <span class="iconfont">&#xe66c;</span>下载
          </div>
        </div>
      </div>
      <Pagination
        v-if="Facelist && Facelist.length > 0"
        :total="hit"
        :currentPage="getCurrentPage"
        :pageSize="20"
        :totalPage="this.totalPage"
        @size-change="handleUpdateData()"
        @handleCurrentChangeSub="handleCurrentChangeSub"
      ></Pagination>
    </div>
    <div class="container_wrapper searchWarn" v-show="!Facelist">
      <i class="wf-icon icon-information"></i
      >没有命中记录，请重试或修改检索表达式
    </div>
  </div>
</template>

<script>
import { reqSearch } from '../api'
import Pagination from '@/common/Pagination'
import { mapState, mapGetters } from 'vuex'
import { READ_URL, RESOURCE_TYPE_ITEM_READ, LOGIN_IN_URL, RESOURCE_TYPE_ITEM_DOWN } from '../store/mutation-types'
export default {
  name: 'ContentArea',
  data () {
    return {
      curPageFlag: 1,
      pageSizeFlag: 20,
      Facelist: [],
      sortType: 'Date',
      BaseUrl: 'http://static.wanfangdata.com.cn/LocalChronicleImages/',
      hit: 0,
      totalPage: 0,
      fq: ['Province:', 'City:'],
      paginationReady: false,
      searchData: {
        query: '',
        fq: [],
        core: 'LocalChronicleItemOpera',
        pageSize: 20,
        pageNo: 1,
        sorts: [{ feild: 'Date', order: 'desc' }]
      },
      defaultImg:
        'this.src="http://static.wanfangdata.com.cn/LocalChronicleImages/FZ201745248.gif"'
    }
  },
  components: {
    Pagination
  },
  props: {
    filterSearchList: Array
    // queryInfo: String
  },
  computed: {
    ...mapState(['filterQueryist', 'searchresult', 'queryInfo', 'userinfo', 'filterShowList']),
    getCurrentPage () {
      const currentPage = this.$route.query.pageNo
      if (currentPage) {
        return currentPage * 1
      } else {
        return 1
      }
    }
  },
  filters: {
    ellipsis (value) {
      if (!value) return
      // let temp = value.replace(/<p>/g, '').replace(/<\/p>/g, '').trim()
      // let temp = value.trim()
      if (value.length > 125) {
        return value.slice(0, 125) + '...'
      }
      return value
    },
    ellipsisTiltle (value) {
      if (!value) return
      if (value.length > 40) {
        return value.slice(0, 40) + '...'
      }
      return value
    },
    ellipsisMessage (value) {
      if (!value) return
      if (value.length > 15) {
        return value.slice(0, 15) + '...'
      }
      return value
    }
  },
  created () {
    // 查看路由携带的参数
    // console.log(window.unescape(this.$route.query.City))
    // console.log(window.unescape(this.$route.query.Province))
    // console.log(window.unescape(this.$route.query.keyword))
    const queryParam = this.$route.query.keyword
    const fqParam = this.$route.query.Province
    if (fqParam) {
      // this.searchData.fq = ['Province:'+ fqParam]
    }
    if (queryParam) {
      this.searchData.query = ''
    }

    if (queryParam !== 'undefined') { // typeof()
      // console.log(window.unescape(this.$route.query.keyword))
      this.searchData.query = queryParam
    }
    // this.searchData.query = this.queryInfo
    // this.searchData.query = this.queryInfo
    this.searchData.fq = this.filterQueryist
    this.handleUpdateData(this.searchData)
  },
  methods: {
    // 清除历史数据
    clearHistoryData () {
      this.Facelist = []
      // this.hit = 0
      // this.hit = data.hit
    },
    // 条目下载
    handleItemDown (id) {
      // 3 条目下载
      this.$store.dispatch('savSourceType', 3)
      if (this.userinfo.users.length) {
        this.$store.dispatch('saveCurrentBookId', 0)
        this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_DOWN)
      } else {
        let counter = 1
        this.$store.dispatch('saveCounter', counter)
        this.$store.dispatch('saveCurrentBookId', id)
        window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
      }
    },
    // 条目阅读
    handleItemRead (id) {
      this.$store.dispatch('savSourceType', 1)
      if (this.userinfo.users.length) {
        this.$store.dispatch('saveCurrentBookId', 0)
        this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_READ)
      } else {
        let counter = 1
        this.$store.dispatch('saveCounter', counter)
        this.$store.dispatch('saveCurrentBookId', id)
        window.location.href = LOGIN_IN_URL + window.location.href
      }
    },
    // 初始化页面方法
    async _initCategory () {
      this.clearHistoryData()
      const result = await reqSearch(this.searchData)
      const data = result.resulter // 获取对象resulter
      this.Facelist = JSON.parse(data.results)
      this.hit = data.hit
      this.totalPage = data.totalPage
      this.curPageFlag = data.curPage
      this.pageSizeFlag = data.pageSize
    },
    // 更新页面数据
    async handleUpdateData (opt) {
      const result = await reqSearch(opt)
      const data = result.resulter // 获取对象resulter
      this.Facelist = JSON.parse(data.results)
      this.hit = data.hit
      this.totalPage = data.totalPage
      this.curPageFlag = data.curPage
      this.pageSizeFlag = data.pageSize
    },
    // 排序
    async handleSort(sortType) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.searchData.sorts[0]['feild'] = sortType
        this.searchData.pageNo = 1
        const keyWord = this.$route.query.query
        if (keyWord) {
          this.$router.replace({ path: 'search', query: { query: keyWord, sortType: sortType, pageNo: this.searchData.pageNo } })
        } else {
          this.$router.replace({ path: 'search', query: { sortType: sortType, pageNo: this.searchData.pageNo } })
        }
        // this.handleCurrentChangeSub(1)
      }
    },
    // 页码变化
    async handleCurrentChangeSub(val) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.searchData.pageNo = val
        // console.log(this.pageNo)
        const keyword = this.$route.query.query
        if (keyword) {
          this.$router.push({ path: 'search', query: { query: keyword, pageNo: this.searchData.pageNo } })
        } else {
          this.$router.push({ path: 'search', query: { pageNo: this.searchData.pageNo } })
        }
      }
    },
    _initQueryRoute () {
      const keyWord = this.$route.query.query
      const pageNo = this.$route.query.pageNo * 1
      const sorts = this.$route.query.sortType
      this.searchData.fq = this.filterQueryist
      if (keyWord && pageNo) {
        this.searchData.query = keyWord
        this.searchData.pageNo = pageNo
      } else if (keyWord && !pageNo) {
        this.searchData.query = keyWord
        this.searchData.pageNo = 1
      } else if (!keyWord && pageNo) {
        this.searchData.query = ''
        this.searchData.pageNo = pageNo
      } else {
        this.searchData.query = ''
        this.searchData.pageNo = 1
      }
      if (sorts) {
        this.searchData.sorts = [{ feild: sorts, order: 'desc' }]
        this.searchData.pageNo = pageNo
      }
      this.handleUpdateData(this.searchData)
    }
  },
  watch: {
    // 多选栏
    filterQueryist (val) {
      this.handleCurrentChangeSub(1)
      this._initQueryRoute()
    },
    filterShowList (val) {
      this.handleCurrentChangeSub(1)
    },

    // 路由
    $route: {
      handler: function (val) {
        if (this.$route.path === '/search') {
          this._initQueryRoute()
        } else {
          // 清空vueX 筛选列表数据
          this.$store.dispatch('savaFilterList', [])
          this.$store.dispatch('savaFilterQuery', [])
        }
      },
      deep: true
    }
  },
  mounted () {
    this._initQueryRoute()
  }

}
</script>

<style lang="less" scoped>
@import url(~styles/varibles.less);
.searchWarn {
  font-size: 16px;
  text-align: center;
  line-height: 500px;
}
.container_wrapper {
  width: 1200px;
  margin: 0 auto;
  min-height: 1108px;
  // 高亮

  .container-inner {
    box-sizing: border-box;
    padding: 20px 0;
    margin: 0 20px;
    //height: 200px;
    border-bottom: 1px solid @line-color;
    font-size: 14px;
    color: #666;
    .left {
      width: 1000px;
      display: inline-block;
      height: 100%;
      .itemTitle {
        .title_hl {
          max-width: 858px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    .right {
      float: right;
      width: 150px;
      //height: 100%;
    }
  }
}
.itemTitle {
  .title {
    font-size: 20px;
    color: #333;
    display: inline-block;
    vertical-align: middle;
    cursor: auto;
  }
  span {
    font-size: 12px;
    background: @area-color;
    color: #fff;
    border-radius: 3px;
    margin-left: 8px;
    vertical-align: middle;
  }
  .itemArea {
    display: inline-block;
    //width: 48px;
    height: 20px;
    padding: 0 2px;
    text-align: center;
    line-height: 20px;
    vertical-align: middle;
    display: inline-block;
    height: 20px;
    padding: 0 2px;
    text-align: center;
    line-height: 20px;
    vertical-align: middle;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 70px;
  }
}
.itemMessage {
  margin-left: -15px;
  span {
    display: inline-block;
    padding: 20px 0;
    vertical-align: middle;
  }
  .item {
    margin-left: 35px;
  }

  .item-mess,
  .item-mess-type {
    //margin-right: 54px;
    display: inline-block;
    font-size: 14px;
    //padding-left: 34px;
    max-width: 102px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .item-mess-type {
    width: 48px;
  }
}
.itemContent {
  background: #f2eeeb;
  max-height: 80px;
  box-sizing: border-box;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.right {
  .reading,
  .loaddown {
    width: 128px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #a31f24;
    color: #fff;
    border-radius: 28px;
    margin-left: 22px;
    cursor: pointer;
    span {
      margin-right: 7px;
    }
  }
  .reading {
    margin-top: -2px;
    margin-bottom: 15px;
  }
}

#app {
  .SortItem {
    .sortBtn {
      cursor: pointer;
      .selectBtn {
        border: 1px solid #94491f;
        color: #fff;
        background: #94491f;

        .iconfont {
          color: #fff;
        }
      }
    }
  }
}

.SortItem {
  font-size: 14px;
  height: 64px;
  line-height: 64px;
  width: 1200px;
  //margin: 18px 30px 13px 30px;
  border-bottom: 1px solid @line-color;
  margin: 0 auto;
  .resultTotal {
    display: inline-block;
    color: #333;
    margin-left: 20px;
    span {
      color: @area-color;
    }
  }
  .sortBtn {
    .selectBtn {
      border: 1px solid #94491f;
      color: #fff;
      .iconfont {
        color: #fff;
      }
    }
    height: 64px;
    float: right;
    line-height: 64px;
    //position: relative;
    .orderByName {
      line-height: 30px;
      display: inline-block;
      border: 1px solid #d5c2b8;
      border-radius: 30px;
      color: #94491f;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 38px;
      line-height: 38px;
      padding-left: 20px;
      padding-right: 14px;
      .iconfont {
        margin-left: 7px;
        color: #ccc;
      }
    }
    .orderByTime {
      line-height: 30px;
      display: inline-block;
      border: 1px solid #d5c2b8;
      border-radius: 30px;
      color: #94491f;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 38px;
      line-height: 38px;
      text-align: center;
      text-align: center;
      padding-left: 18px;
      padding-right: 14px;
      margin-left: 10px;
      .iconfont {
        color: #ccc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/ContentArea.vue